<app-score-dashboard
    [title]="'Overall Throughput Volumes '"
    [centerText]="'Total Throughput'"
    [showScore]="true"
    [showTrending]="false"
    [showBreakdownCharts] = "false"
    [loadScoreData]="loadScoreData"
    [exportData]="exportData"
    [formatMode] = "'decimal'"
    [palette]="palette"
    (dateRangeChanged)="onDateRangeChanged($event)">

    <ng-container intermediate-content>
        @if (summary$ | async) {
            <app-summary-card [items]="summaryCards" class="mb-4"></app-summary-card>
        }
    </ng-container>
</app-score-dashboard>
